const maskAboNumber = (aboNo: string): string => {
  if (!aboNo) return "";

  const visible = aboNo.slice(0, 3);
  const masked = "*".repeat(Math.max(0, aboNo.length - 3));

  return visible + masked;
};

export default maskAboNumber;
